import _ from 'lodash';
export const toCamelCase = <T>(data: Array<object> | object): T[] | object => {
  if (Array.isArray(data)) {
    // 如果是数组，遍历每个元素并递归处理
    return _.map(data, item => {
      return toCamelCase(item);
    });
  } else if (typeof data === 'object' && data !== null) {
    // 如果是对象，使用 _.transform 进行转换
    return _.transform(
      data,
      (
        result: { [key in string]: object },
        value: object,
        key: keyof typeof data
      ) => {
        const camelKey = toCamelCaseString(key);
        result[camelKey] = toCamelCase(value); // 递归处理值
      }
    );
  }
  // 如果是基本类型，直接返回
  return data;
};
export const toSnakeCase = <T>(data: Array<object> | object): T[] | object => {
  if (Array.isArray(data)) {
    // 如果是数组，遍历每个元素并递归处理
    return _.map(data, item => {
      return toSnakeCase(item);
    });
  } else if (typeof data === 'object' && data !== null) {
    // 如果是对象，使用 _.transform 进行转换
    return _.transform(
      data,
      (
        result: { [key in string]: object },
        value: object,
        key: keyof typeof data
      ) => {
        const camelKey = toSnakeCaseString(key);
        result[camelKey] = toSnakeCase(value); // 递归处理值
      }
    );
  }
  // 如果是基本类型，直接返回
  return data;
};
export const toSnakeCaseString = (str: string) => {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
};
export const toCamelCaseString = (str: string) => {
  return str.replace(/(_\w)/g, (_, letter) => {
    return letter.toUpperCase().replace('_', '');
  });
};
